import http, { url } from '../../http'

const API_URL = "evidence_health_conditions"

class perfilSociodemograficoAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getGrafica(id) {
    const response = await http(`${API_URL}/reportDiagram/${id}`)
    return response
  } 
/*   async getAll(page) {
    const response = await http(`${API_URL}?page=${page}`)
    return response
  } 
 */
  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`,  'POST')
    return response
  } 

/*   async getAll(id, page) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}`)
    return response
  }  */
 
  async get(id) {
    const response = await http(`${API_URL}/index/${id}`,  'POST')
    return response
  }
/* 
  async getExcel(id) {
    const response = url(`${API_URL}/excelAdvance/${id}`)
    return response
  }  */

  async getExcel(companyId) {
    let user = JSON.parse(localStorage.getItem('user'))

    if(user.token){
      return url(`${API_URL}/report/${companyId}?&access_token=${user.token}`)
    } 


  /*     let user = JSON.parse(localStorage.getItem('user'))
    const response = url(`${API_URL}/excelAdvance/${id}`, {
      access_token: user.token,
    }) */
  }


  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new perfilSociodemograficoAPI()